import { useState } from 'react';

export const INITIAL_STEP_INDEX = 0;

interface UseStepNavigation<Step, StepKey> {
  isFirstStep: boolean;
  isLastStep: boolean;
  nextStep: () => void;
  previousStep: () => void;
  progress: number;
  step: Step;
  stepKey: StepKey;
}

export const useStepNavigation = <Step, StepKey>(steps): UseStepNavigation<Step, StepKey> => {
  const [navigationIndex, setNavigationIndex] = useState(INITIAL_STEP_INDEX);

  const [stepKey, step] = steps[navigationIndex];

  const nextStep = () =>
    setNavigationIndex(state => (state === steps.length - 1 ? state : state + 1));

  const previousStep = () => setNavigationIndex(state => (state === 0 ? state : state - 1));

  const progress = (navigationIndex + 1) * (100 / steps.length);

  const isFirstStep = navigationIndex === 0;

  const isLastStep = steps.length - 1 === navigationIndex;

  return {
    isFirstStep,
    isLastStep,
    nextStep,
    previousStep,
    progress,
    step,
    stepKey,
  };
};
